import mutations from '@/store/modules/de/de.mutations';

// import { mutations } from './app.mutations';
export interface State {
  currentDeTab: string;
}
const initialState: State = {
  currentDeTab: '',
};
export default {
  namespaced: true,
  state: initialState,
  mutations: mutations,
};
